import { googleLogout, useGoogleLogin } from "@react-oauth/google";
import { useDispatch } from 'react-redux';
import { AppDispatch } from "../store/store";
import { login, logout } from "../store/userDetailsSlice";
import { fetchInitialSavedPlaces, resetSavedPlaces } from "../store/savedPlacesSlice";

export default function useGoogleSignIn(onSignInSuccess?: () => void) {
    const dispatch = useDispatch<AppDispatch>();

    const initiateGoogleSignIn = useGoogleLogin({
        onSuccess: (codeResponse:any) => {
            fetchGoogleUserProfile(codeResponse).then((userId: string) => {
                dispatch(login(userId));
                dispatch(fetchInitialSavedPlaces(userId));
                onSignInSuccess?.();
            });
        },
        onError: () => console.log('Login Failed:')
    });

    const initiateGoogleSignOut = () => {
        googleLogout();
        dispatch(logout());
        dispatch(resetSavedPlaces())
    };

    return { initiateGoogleSignIn, initiateGoogleSignOut };
}

async function fetchGoogleUserProfile(user: any) {
    if (!user) {
        throw new Error("User details are missing");
    };

    try {
        const response = await fetch(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`, {
            headers: {
                Authorization: `Bearer ${user.access_token}`,
                Accept: 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        if(!data.id){
          throw new Error(`Failed to get userId`);
        }
        return data.id;
    } catch (error) {
        console.log(error);
        throw error;
    }
};
